<script>
    import active from "svelte-spa-router/active";

    let links = [
        {href: "#/bundles", text: "Bundles"},
        {href: "#/materials", text: "Materials"},
        {href: "#/props", text: "Props"},
        {href: "#/resources", text: "Resources"},
        {href: "#/locomotives", text: "Locomotives"},
        {href: "#/railcars", text: "Railcars"},
        {href: "#/perks", text: "Perks"},
        {href: "#/levels", text: "Levels"},
        {href: "#/productions", text: "Productions"},
        {href: "#/uploader", text: "Uploader"},
        {href: "#/builder", text: "Builder"},
        {href: "#/game_builds", text: "GameBuilds"},
    ];
</script>

<nav
    class="select-none main-navbar relative w-full flex flex-wrap items-center justify-between bg-custom text-gray-500 hover:text-gray-700 focus:text-gray-700 shadow-lg navbar navbar-expand-lg navbar-light"
>
    <div class="container flex flex-wrap items-center justify-between px-6">
        <ul class="navbar-nav flex pl-0 list-style-none mr-auto text-lg">
            {#each links as row}
                <li class="nav-item p-2">
                    <a
                        class="nav-link text-white focus:text-gray-500 p-0 transition-colors"
                        href={row.href}
                        use:active>{row.text}</a
                    >
                </li>
            {/each}
        </ul>
    </div>
</nav>

<style>
    .main-navbar {
        background-color: #ffcc05;
    }
</style>
